import { SatisfiesShape } from "@nens/shared-utils";

import { FileDataTypeEnum } from "@/lib/rana-file-data-type";

import { GenericLayer, Layer, RasterLayer, VectorLayer } from "../types/publication";

export const FILE_DATA_TYPE_TO_LAYER_TYPE: Record<
  FileDataTypeEnum,
  NonNullable<Layer["properties"]>["type"] | null
> = {
  raster: "raster",

  vector: "generic",

  scenario: null,
  threedi_schematisation: null,
  ogc_3d_tiles: null,
  text: null,
  code: null,
  image: null,
  shapefile: null,
};

export type PropertTypeToLayerTypeMap = SatisfiesShape<
  Record<FileDataTypeEnum, Layer>,
  {
    raster: RasterLayer;
    scenario: RasterLayer;

    vector: VectorLayer;

    threedi_schematisation: GenericLayer;
    ogc_3d_tiles: GenericLayer;
    text: GenericLayer;
    code: GenericLayer;
    image: GenericLayer;
    shapefile: GenericLayer;
  }
>;

export function isTypedLayer<T extends FileDataTypeEnum>(
  layer: Layer | undefined,
  dataType: T
): layer is PropertTypeToLayerTypeMap[T] {
  return !!layer && layer.dataType === dataType;
}
